export default __webpack_public_path__ + "static/media/PHÂN HỆ QUẢN LÝ VIỆN PHÍ.a981ec34.pdf";